import React from 'react';

export const PinterestIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 36 36">
      <path
        data-name="Path 15241"
        d="M18 0a18 18 0 1 0 18 18A18 18 0 0 0 18 0zm1.453 24.1c-1.361-.105-1.933-.78-3-1.428-.587 3.077-1.3 6.027-3.427 7.569-.656-4.651.962-8.145 1.713-11.853-1.281-2.156.154-6.5 2.856-5.427 3.325 1.315-2.879 8.018 1.286 8.855 4.348.874 6.123-7.545 3.427-10.283-3.9-3.953-11.34-.09-10.425 5.57.223 1.384 1.653 1.8.571 3.713-2.492-.548-3.236-2.516-3.14-5.136.154-4.292 3.856-7.3 7.569-7.712 4.7-.526 9.1 1.724 9.712 6.141.684 4.985-2.12 10.384-7.141 9.997z"
        transform="translate(-.001 -.002)"
        style={{ fill: fill || '#181d56' }}
      />
    </svg>
  );
};
